import React from 'react';
import PropTypes from 'prop-types';

import MuiTextField from '@material-ui/core/TextField';

import { useTextFieldStyles } from './styles';

const TextField = ({ maxLength, ...rest }) => {
	const textFiledClasses = useTextFieldStyles();

	return (
		<MuiTextField
			// Variant="filled"
			// size="small"
			inputProps={{
				maxLength
			}}
			classes={textFiledClasses}
			{...rest}
		/>
	);
};

TextField.propTypes = {
	maxLength: PropTypes.number
};

export default TextField;
